"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DefaultButtonBar = void 0;
var tslib_1 = require("tslib");
// (C) 2021-2022 GoodData Corporation
var react_1 = tslib_1.__importDefault(require("react"));
var button_1 = require("./button");
/**
 * @alpha
 */
exports.DefaultButtonBar = function (props) {
    var children = props.children, cancelButtonProps = props.cancelButtonProps, saveButtonProps = props.saveButtonProps, editButtonProps = props.editButtonProps, saveAsNewButtonProps = props.saveAsNewButtonProps, shareButtonProps = props.shareButtonProps;
    // TODO INE allow customization of buttons via getter from props
    return (react_1.default.createElement("div", { className: "dash-control-buttons" },
        children,
        react_1.default.createElement(button_1.CancelButton, tslib_1.__assign({}, cancelButtonProps)),
        react_1.default.createElement(button_1.SaveButton, tslib_1.__assign({}, saveButtonProps)),
        react_1.default.createElement(button_1.EditButton, tslib_1.__assign({}, editButtonProps)),
        react_1.default.createElement(button_1.SaveAsNewButton, tslib_1.__assign({}, saveAsNewButtonProps)),
        react_1.default.createElement(button_1.ShareButton, tslib_1.__assign({}, shareButtonProps))));
};
//# sourceMappingURL=DefaultButtonBar.js.map